import { render, staticRenderFns } from "./subdeal.vue?vue&type=template&id=612b3264&scoped=true&"
import script from "./subdeal.vue?vue&type=script&lang=js&"
export * from "./subdeal.vue?vue&type=script&lang=js&"
import style0 from "./subdeal.vue?vue&type=style&index=0&id=612b3264&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612b3264",
  null
  
)

export default component.exports